import { render, staticRenderFns } from "./customize_gift.vue?vue&type=template&id=68b71d00&scoped=true"
import script from "./customize_gift.vue?vue&type=script&lang=js"
export * from "./customize_gift.vue?vue&type=script&lang=js"
import style0 from "./customize_gift.vue?vue&type=style&index=0&id=68b71d00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b71d00",
  null
  
)

export default component.exports